module.exports = "<div class=\"jumbotron\">\r\n    <h1 class=\"display-3\">Angular + Cryptocurrency</h1>\r\n    <p>This site has been built purely using angular. It accesses open web apis from cryptocurrency sites</p>\r\n    <p><a class=\"btn btn-primary btn-lg\" target=\"_blank\" href=\"https://github.com/jacobkuriala/angularcoin\">Learn more</a></p>\r\n  </div>\r\n"


//////////////////
// WEBPACK FOOTER
// c:/WebProjects/angularcoin/src/app/component/about/about.component.html
// module id = ../../../../../src/app/component/about/about.component.html
// module chunks = main